/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const ROUTES = {
  index: "/",
  archive: "/archive",
  resource: "/estate/:nordcloudId",
  settings: {
    index: "/settings",
    employees: "/settings/employees",
    users: "/settings/users-and-permissions",
    costSplitting: "/settings/cost-splitting-rules",
    mapping: "/settings/mapping-rules",
    reports: "/settings/reports",
    organization: "/settings/organization",
    cloudWaste: "/settings/savings-suggestions",
  },
  applications: {
    index: "/applications",
    create: "/applications/create-new",
    details: "/applications/:application",
    environment: "/applications/:application/:environment",
  },
  costAnalysis: {
    index: "/cost-analysis",
  },
  estateRecords: {
    index: "/estate",
    indexV2: "/estate-records",
    drift: "/drift",
  },
  reservedInstances: {
    index: "/reservations-and-commitments",
    azureReservation: "/reservations-azure",
  },
  externalIntegrations: {
    index: "/external-integrations",
    details: "/external-integrations/:integrationId",
    create: "/external-integrations/add-integration",
  },
  accounts: {
    index: "/accounts",
    details: "/accounts/:accountId",
    edit: "/accounts/:accountId/edit",
    add: "/accounts/add",
    addBillingData: "/accounts/add-billing-data",
  },
  cloudAccounts: {
    index: "/cloud-accounts",
    details: "/cloud-accounts/:nid",
  },
  notifications: {
    index: "/notifications",
  },
  business: {
    unitTypes: "/organization-unit-types",
  },
  businessContexts: {
    index: "/business-contexts",
    unit: "/business-contexts/unit",
    detailsSimple: "/business-contexts/unit/:unitId",
    structure: "/business-contexts/:structureId",
    details: "/business-contexts/:structureId/:unitId",
  },
  finopsKpi: {
    index: "/finops-kpi",
  },
  workflows: {
    index: "/workflows",
    details: "/workflows/:workflowId",
    create: "/workflows/add-workflow",
  },
  integrationPlugins: {
    index: "/integration-plugins",
    details: "/integration-plugins/:pluginId",
    create: "/integration-plugins/add-plugin",
  },
  releaseNotes: "/release",
  api: "/graphql",
  export: "/exports/:exportJobId/download",
  selectCustomer: "/select-customer",
  notFound: "/404",
  accessDenied: "/access-denied",
};
